import { useBoolean } from "usehooks-ts";

import { CustomPopover } from "src/base-components/Popover";
import { Pill } from "src/design-system/Pill";

export const ClampedItems: React.FC<{
  items: React.JSX.Element[];
  maxVisibleItems?: number;
}> = ({ items, maxVisibleItems = 3 }) => {
  const { value: isOpen, setFalse, setTrue } = useBoolean(false);

  if (items.length <= maxVisibleItems) {
    return items;
  }

  const [visibleItems, rest] = [
    items.slice(0, maxVisibleItems),
    items.slice(maxVisibleItems),
  ];
  const button = (
    <div className="flex">
      <Pill size="sm" variant="gray">
        <Pill.Text>+{rest.length}</Pill.Text>
      </Pill>
    </div>
  );

  return (
    <>
      <div className="flex min-w-0 items-center gap-1 overflow-hidden">
        {visibleItems}
      </div>
      <CustomPopover
        button={button}
        isOpen={isOpen}
        offsetX={0}
        wrapperClassName="flex shrink-0 items-center"
        onMouseEnter={setTrue}
        onMouseLeave={setFalse}
      >
        <div className="flex flex-col items-start gap-y-5 px-4 py-2">
          {rest}
        </div>
      </CustomPopover>
    </>
  );
};
